import { createControlId, destructureControlId } from '@avantia/questionset-model';
import { HpInputControlProps } from '../../../types/inputControlTypes';
import { HpCheckBoxItemProps } from './checkBoxControl';
import { CheckBoxListControlWithCustomContent } from './checkBoxListControl';

export type RadioListControlProps = HpInputControlProps;

type HpRadioItemProps = HpCheckBoxItemProps;

export function RadioListControl(props: RadioListControlProps): JSX.Element {
  return CheckBoxListControlWithCustomContent(
    props,
    (optionProps) => <RadioItem key={optionProps.itemKey} {...optionProps} />,
    'btn-group btn-group-vertical btn-group-toggle'
  );
}

export function RadioItem({
  disabled,
  id,
  isChecked,
  itemKey,
  name,
  onClick,
  onKeyPress,
  optionText
}: HpRadioItemProps): JSX.Element {
  const { questionId, key, groupNumber } = destructureControlId(itemKey);
  const labelId = createControlId({ questionId, key, groupNumber, options: { customPrefix: 'L' } });
  return (
    <div className="hp-radio-list">
      <input disabled={disabled === true} id={labelId} name={name || id} onClick={onClick} type="checkbox" />
      <label
        className={`btn${isChecked ? ' active' : ''} btn-primary form-check-label`}
        htmlFor={itemKey}
        tabIndex={0}
        onKeyPress={onKeyPress}
        id={itemKey}
        onClick={onClick}
      >
        <div className="av-icon">
          <div className="av-icon-inner"></div>
        </div>
        <span className="av-label-text">{optionText as string}</span>
      </label>
    </div>
  );
}
